export default "__VITE_ASSET__DDpMeDs3__"